import apiClient from 'utilities/apiClient';

export const get_pv = (url, payload) => {
  return apiClient.get(
    `${apiClient.Urls.productVerification}/${url}`,
    payload,
    true
  );
};

export const post_pv = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.productVerification}/${url}`,
    payload,
    true
  );
};

export const get_tolerance_master = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.verificationTolerances}/`,
    payload,
    true
  );
};
